/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for ACESUserInfo.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_GET_GENDER_EMAIL_ADDRESS = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `ACESUSERINFO/FETCH_GET_GENDER_EMAIL_ADDRESS`
);

const POST_MODIFY_EMAIL_ADDRESS = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESUSERINFO/POST_MODIFY_EMAIL_ADDRESS`
);

export { FETCH_GET_GENDER_EMAIL_ADDRESS, POST_MODIFY_EMAIL_ADDRESS };
